import React from 'react'

export const PickingTypes = [
  { value: 'Consolidado', label: 'Consolidado' },
  { value: 'PorCliente', label: 'Por Cliente' },
  { value: 'PorPallet', label: 'Por Pallet' },
  { value: 'CitroSucoEntrada01', label: 'CIT-Entrada' },
  { value: 'CitroSucoSaida01', label: 'CIT-Saida' },
  { value: 'Consol. Por Origem', label: 'Consol. Por Origem' },
  { value: 'Informar Origem', label: 'Informar Origem' },
  { value: 'Recebimento', label: 'Recebimento' },
  { value: 'PorClienteEstoque', label: 'Por Cliente - Estoque' },
]

export default function PickingType({ type }) {
  //
  function getPickingsType() {
    switch (type) {
      case 'Consolidado':
        return <span style={{ color: 'orange' }}>Consolidado</span>
      case 'PorCliente':
        return <span style={{ color: 'blue' }}>Por Cliente</span>
      case 'PorPallet':
        return <span style={{ color: 'pink' }}>Por Pallet</span>
      case 'CitroSucoEntrada01':
        return <span style={{ color: 'green' }}>CIT-Entrada</span>
      case 'CitroSucoSaida01':
        return <span style={{ color: 'brown' }}>CIT-Saida</span>
      case 'Consol. Por Origem':
        return <span style={{ color: 'red' }}>Consol. Por Origem</span>
      case 'Informar Origem':
        return <span style={{ color: 'blue' }}>Informar Origem</span>
      case 'Recebimento':
        return <span style={{ color: 'purple' }}>Recebimento</span>
      case 'PorClienteEstoque':
        return <span style={{ color: 'green' }}>Por Cliente - Estoque</span>
      default:
        return <span>{type}</span>
    }
  }

  // Render
  return getPickingsType()
}
